export enum CustomerRiskManagementThirdParty {
  Bndry = "Bndry",
  Au10Tix = "Au10Tix",
}

export const CustomerRiskManagementThirdPartyList = () =>
  Object.entries(CustomerRiskManagementThirdParty).map(([label, value]) => {
    return { label, value };
  });
